import { render, staticRenderFns } from "./PromotionRates.vue?vue&type=template&id=c52d47e2&"
import script from "./PromotionRates.vue?vue&type=script&lang=js&"
export * from "./PromotionRates.vue?vue&type=script&lang=js&"
import style0 from "./PromotionRates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PromotionRates.vue"
export default component.exports